import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { MapsAPILoader, AgmMap } from '@agm/core';
import { Router } from '@angular/router';
import { AlertService } from '../services/alert/alert.service';
import { ApiService } from '../services/api/api.service';

@Component({
  selector: 'app-current-location',
  templateUrl: './current-location.page.html',
  styleUrls: ['./current-location.page.scss'],
})
export class CurrentLocationPage implements OnInit {
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  city: any;
  private geoCoder;


  @ViewChild('search',{static:false})
  public searchElementRef: ElementRef;

  constructor(    
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    public alert: AlertService,
    private api : ApiService
    ) { }

    ngOnInit() {
      //load Places Autocomplete
      this.mapsAPILoader.load().then(() => {
        this.setCurrentLocation();
        this.geoCoder = new google.maps.Geocoder;
  
        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          types: ["address"]
        });
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            //get the place result
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();
  
            //verify result
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
  
            //set latitude, longitude and zoom
            this.latitude = place.geometry.location.lat();
            this.longitude = place.geometry.location.lng();
            this.getAddress(this.latitude, this.longitude);
            this.zoom = 12;
          });
        });
      });
    }


    // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }


  markerDragEnd($event: any) {
    console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress(this.latitude, this.longitude);
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      console.log(results);
      console.log(status);
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
           //find country name
           for (var i=0; i<results[0].address_components.length; i++) {
            for (var b=0;b<results[0].address_components[i].types.length;b++) {
              // case 'locality':
              //   location['city'] = component.long_name;
              //   break;
              // case 'administrative_area_level_1':
              //     location['state'] = component.long_name;
              //     break;
              // case 'country':
              //     location['country'] = component.long_name;
              //     break;
            //there are different types that might hold a city admin_area_lvl_1 usually does in come cases looking for sublocality type will be more appropriate
                if (results[0].address_components[i].types[b] == "locality") {
                    //this is the object you are looking for
                    this.city = results[0].address_components[i];
                    break;
                }
            }
        }

        } else {
          this.alert.presentAlert('No results found','','Please try again later')
        }
      } else {
        this.alert.presentAlert('Failed','','Geocoder failed due to: ' + status);
      }

    });
  }

  saveCurrentLocation(){
    this.api.setlatitude(this.latitude)
    this.api.setlongitude(this.longitude)
    this.api.setaddress(this.address)
    this.router.navigate(['/market'])
  }

}
